import React from 'react'
import styled from 'styled-components'

// Import Page Level Components
import NavPrimary from '../../components/layouts/NavPrimary.js'
import SecondaryNav from '../../components/layouts/NavSecondary.js'
import Footer from '../../components/layouts/Footer.js'
import GContentCarrierResultsQuoteSummary from '../../components/ContentGrids/Quote/CarrierResultsTwoContentGrid.js'


const PGComponentCarrierResultsQuoteSummary = styled.div`
  body {
    @import url('https://fonts.googleapis.com/css?family=Teko');
    font-family: 'Teko', sans-serif;
  }
  height: 100vh;
  background-color: #fff;
  // 🖋
  font-family: 'Open Sans';
  // 📰
  display: grid;
  grid-template-rows: 0.1fr 0.3fr 0.2fr 5fr 0.2fr;
  grid-template-columns: 1fr;
  grid-template-areas:
    "nav_secondary"
    "nav_primary"
    "page_title"
    "g_content"
    "g_footer";

  .NavPrimary {
    grid-area: nav_primary; // 🗺
    align-self: start;
  }
  .SecondaryNav {
    grid-area: nav_secondary; // 🗺
    align-self: start;
  }
  .PageTitle {
    grid-area: page_title; // 🗺
    align-self: start;
  }
  .GComponentContent {
    grid-area: g_content; // 🗺
  }
  .Footer {
    grid-area: g_footer; // 🗺
    align-self: end;
  }
`;
const GComponentContent = styled.div`
  width: 100%;
`;
const GComponentPageTitle = styled.div`
    margin-top: 20px;
    margin-bottom: 10px;
    width: 100%;  
`;
const PageTitle = styled.div`
    font-family: 'Teko', sans-serif;
    text-transform: uppercase;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-weight: 400;
    line-height: 1.5;
    font-size: 30px;
    color: #141b1f;
    margin: 0 auto;
    max-width: 1360px;
`;

const PageGridComponentSelectCarrier = () => {
  return (
    <PGComponentCarrierResultsQuoteSummary>
      <SecondaryNav></SecondaryNav>
      <NavPrimary></NavPrimary>
      <GComponentPageTitle>
          <PageTitle>Carrier Results for Quote #2346926</PageTitle>
      </GComponentPageTitle>
      <GComponentContent>
          <GContentCarrierResultsQuoteSummary>
            
          </GContentCarrierResultsQuoteSummary>
      </GComponentContent>
      <Footer></Footer>
    </PGComponentCarrierResultsQuoteSummary>
  )
}

export default PageGridComponentSelectCarrier;